// import { text } from "@fortawesome/fontawesome-svg-core";
// import React, { useEffect, useRef } from "react";

// export default function CustomerLogo() {
//   const logos = [
//     // "https://alce.co.in/static/media/image.fc1d7a51bf59b88d4eab.png",
//     "https://www.dextratechnologies.com/theme/imgs/logo.webp",
//     // "https://optunetechnologies.com/static/media/logo.3945db08ef5ccc5b9452.webp",
//     // "https://auroraacademy.co.in/assert/images/logo.webp",
//     // "https://daco.co.in/images/logo.png",
//     // "https://quantzi.co/images/quantzi-logo.webp",
//     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdxpB8Ee8QPYapjx0JDy6lPXfxU_-5zK52qHxqvGoeHgRRZh-MmaPkn0hPTDtmtqJMzD8&usqp=CAU",
//     "https://www.bluestonefoundation.in/images/logo.jpg",
//     "https://5.imimg.com/data5/RG/PF/KW/SELLER-4109314/untitled-1-90x90.jpg",
//     "https://speedy.uenicdn.com/d472f065-8cdd-4e1c-83e2-26d69cee6fef/n128_128a/image/upload/v1572447204/business/d472f065-8cdd-4e1c-83e2-26d69cee6fef/JKSFOODS-LOGOjpg.jpg",
//     "https://www.bharathuniv.ac.in/images/bharath-logo.png",
//     "img/client-logo/Datayaan.png",
//     "img/client-logo/cms-w-lg.svg",
//     "img/client-logo/Perfect-Computers-logo.png",
//     "img/client-logo/SR-Residency-Logo.png",
//     "img/client-logo/Udhayam-Printers-logo.png",
//     "img/client-logo/logotdy.png",
//     "img/client-logo/tina-logo.jpeg",
//     "img/client-logo/ramco-logo.webp",
//     "img/client-logo/Hi-Tech-Enterprises.webp",
//     "img/client-logo/Group-251@2x-pvfb7la6kv04jq46abe18pjfn3wejvmt4v5dmwffga.png",
//     "img/client-logo/logo_6465a7e5a218a686814273.png"
//   ];

//   const logos_2 = [
//     "img/client-logo/logo6.a40ea70c6ece078011f9.png",
//     "img/client-logo/logo7.3c353fc8d04b1caaef0b.png",
//     "img/client-logo/logo8.e111aff5213e932fbc4d.png",
//     "img/client-logo/logo3.f2a61c8c1e1569296be7.png",
//     "img/client-logo/venus_exports_logo.jpg",
//     "img/client-logo/sreechandra_logo.png",
//     "img/client-logo/sreebogarprojects_logo.png",
//     "img/client-logo/thirutravels_logo.png",
//     "img/client-logo/alucoatindia_logo.png",
//     "img/client-logo/nazaindia-logo.png",
//     "img/client-logo/vivimed-logo.png",
//     "img/client-logo/Marc_Realty_Logo_grey.svg",
//     "img/client-logo/mutharamman_logo.png",
//     "img/client-logo/sisha_logo.webp",
//     "img/client-logo/bharath-leathers.png",
//     "img/client-logo/S&P-logo.png",
//     "img/client-logo/offimartbiz-logo-1719449748.jpg",
//     "img/client-logo/JD-Constructions-logo.png",
//     "img/client-logo/RKC-Constructions-logo.png",
//   ];

//   const scrollContainerRef1 = useRef(null);
//   const scrollContainerRef2 = useRef(null);
//   const animationRef1 = useRef(null);
//   const animationRef2 = useRef(null);

//   const startScrolling = (containerRef, direction, animationRef) => {
//     const container = containerRef.current;
//     if (!container) return;

//     let scrollPosition = container.scrollLeft;
//     const speed = .5; // Adjust this value to control speed (higher = faster)

//     const scroll = () => {
//       scrollPosition += direction === "left" ? speed : -speed; // Adjust speed here
//       container.scrollLeft = scrollPosition;

//       // Reset for seamless scrolling
//       if (scrollPosition >= container.scrollWidth / 2) {
//         scrollPosition = 0;
//       } else if (scrollPosition <= 0) {
//         scrollPosition = container.scrollWidth / 2;
//       }

//       animationRef.current = requestAnimationFrame(scroll);
//     };

//     animationRef.current = requestAnimationFrame(scroll);
//   };


//   const stopScrolling = (animationRef) => {
//     cancelAnimationFrame(animationRef.current);
//   };

//   useEffect(() => {
//     startScrolling(scrollContainerRef1, "left", animationRef1);
//     startScrolling(scrollContainerRef2, "right", animationRef2);

//     return () => {
//       stopScrolling(animationRef1);
//       stopScrolling(animationRef2);
//     }; // Cleanup on component unmount
//   }, []);

//   const styles = {
//     wrapper: {
//       padding: "30px 0",
//       background: "linear-gradient(90deg, #e3f2fd, #f9fbe7)",
//       display: "flex",
//       flexDirection: "column",
//       // justifyContent: "center",
//       // alignItems: "center",
//       textAlign:'left',
//       gap: "20px",
//       overflow: "hidden",
//     },
//     scrollContainer: {
//       display: "flex",
//       gap: "20px",
//       whiteSpace: "nowrap",
//       overflowX: "hidden",
//       width: "100%",
//     },
//     logoItem: {
//       flexShrink: 0,
//       width: "120px",
//       height: "90px",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       backgroundColor: "#fff",
//       borderRadius: "15px",
//       boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//       overflow: "hidden",
//       padding: "10px",
//       cursor: "pointer",
//       transition: "transform 0.3s ease, box-shadow 0.3s ease",
//     },
//     logoImage: {
//       maxWidth: "100%",
//       maxHeight: "100%",
//       objectFit: "contain",
//     },
//   };

//   return (
//     <>
//       <div style={styles.wrapper}>
//         {/* First Layer */}
//         <h2 style={{ fontSize: "1.8rem", fontWeight: "bold", color: "#333", marginBottom: "20px",textAlign:'left',marginLeft:'22px' }}>
//            Our Clients
//         </h2>
//         <div
//           ref={scrollContainerRef1}
//           style={styles.scrollContainer}
//           onMouseEnter={() => stopScrolling(animationRef1)}
//           onMouseLeave={() => startScrolling(scrollContainerRef1, "left", animationRef1)}
//         >
//           {logos.concat(logos).map((logo, index) => (
//             <div style={styles.logoItem} key={`layer1-${index}`}>
//               <img
//                 src={logo}
//                 alt={`Customer Logo ${index + 1}`}
//                 style={styles.logoImage}
//               />
//             </div>
//           ))}
//         </div>

//         {/* Second Layer */}
//         <div
//           ref={scrollContainerRef2}
//           style={styles.scrollContainer}
//           onMouseEnter={() => stopScrolling(animationRef2)}
//           onMouseLeave={() => startScrolling(scrollContainerRef2, "right", animationRef2)}
//         >
//           {logos_2.concat(logos_2).map((logo, index) => (
//             <div style={styles.logoItem} key={`layer2-${index}`}>
//               <img
//                 src={logo}
//                 alt={`Customer Logo ${index + 1}`}
//                 style={styles.logoImage}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useEffect, useRef, useState } from "react";

export default function CustomerLogo() {
  const [serviceCounts, setServiceCounts] = useState({
    audit: 95,
    legal: 238,
    man_power: 60,
    more_services: 31
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const logos = [
    "https://www.dextratechnologies.com/theme/imgs/logo.webp",
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdxpB8Ee8QPYapjx0JDy6lPXfxU_-5zK52qHxqvGoeHgRRZh-MmaPkn0hPTDtmtqJMzD8&usqp=CAU",
    "https://www.bluestonefoundation.in/images/logo.jpg",
    "https://5.imimg.com/data5/RG/PF/KW/SELLER-4109314/untitled-1-90x90.jpg",
    "https://speedy.uenicdn.com/d472f065-8cdd-4e1c-83e2-26d69cee6fef/n128_128a/image/upload/v1572447204/business/d472f065-8cdd-4e1c-83e2-26d69cee6fef/JKSFOODS-LOGOjpg.jpg",
    "https://www.bharathuniv.ac.in/images/bharath-logo.png",
    "img/client-logo/Datayaan.png",
    "img/client-logo/cms-w-lg.svg",
    "img/client-logo/Perfect-Computers-logo.png",
    "img/client-logo/SR-Residency-Logo.png",
    "img/client-logo/Udhayam-Printers-logo.png",
    "img/client-logo/logotdy.png",
    "img/client-logo/tina-logo.jpeg",
    "img/client-logo/ramco-logo.webp",
    "img/client-logo/Hi-Tech-Enterprises.webp",
    "img/client-logo/Group-251@2x-pvfb7la6kv04jq46abe18pjfn3wejvmt4v5dmwffga.png",
    "img/client-logo/logo_6465a7e5a218a686814273.png"
  ];

  const logos_2 = [
    "img/client-logo/logo6.a40ea70c6ece078011f9.png",
    "img/client-logo/logo7.3c353fc8d04b1caaef0b.png",
    "img/client-logo/logo8.e111aff5213e932fbc4d.png",
    "img/client-logo/logo3.f2a61c8c1e1569296be7.png",
    "img/client-logo/venus_exports_logo.jpg",
    "img/client-logo/sreechandra_logo.png",
    "img/client-logo/sreebogarprojects_logo.png",
    "img/client-logo/thirutravels_logo.png",
    "img/client-logo/alucoatindia_logo.png",
    "img/client-logo/nazaindia-logo.png",
    "img/client-logo/vivimed-logo.png",
    "img/client-logo/Marc_Realty_Logo_grey.svg",
    "img/client-logo/mutharamman_logo.png",
    "img/client-logo/sisha_logo.webp",
    "img/client-logo/bharath-leathers.png",
    "img/client-logo/S&P-logo.png",
    "img/client-logo/offimartbiz-logo-1719449748.jpg",
    "img/client-logo/JD-Constructions-logo.png",
    "img/client-logo/RKC-Constructions-logo.png",
  ];

  const scrollContainerRef1 = useRef(null);
  const scrollContainerRef2 = useRef(null);
  const animationRef1 = useRef(null);
  const animationRef2 = useRef(null);
  const [isHovering1, setIsHovering1] = useState(null);
  const [isHovering2, setIsHovering2] = useState(null);

  // Fetch service counts from API
  useEffect(() => {
    const fetchServiceCounts = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          "https://dalmaf.com/dalmaf/v1/services/count"
        );
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        
        if (result.statusCode === 200 && result.data) {
          setServiceCounts(result.data);
        } else {
          throw new Error(result.message || "Failed to fetch service counts");
        }
      } catch (err) {
        console.error("Error fetching service counts:", err);
        setError(err.message);
        // Keep default values if API fails
      } finally {
        setLoading(false);
      }
    };

    fetchServiceCounts();
  }, []);

  const startScrolling = (containerRef, direction, animationRef) => {
    const container = containerRef.current;
    if (!container) return;

    let scrollPosition = container.scrollLeft;
    const speed = 0.6;

    const scroll = () => {
      scrollPosition += direction === "left" ? speed : -speed;
      container.scrollLeft = scrollPosition;

      if (scrollPosition >= container.scrollWidth / 2) {
        scrollPosition = 0;
      } else if (scrollPosition <= 0) {
        scrollPosition = container.scrollWidth / 2;
      }

      animationRef.current = requestAnimationFrame(scroll);
    };

    animationRef.current = requestAnimationFrame(scroll);
  };

  const stopScrolling = (animationRef) => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }
  };

  useEffect(() => {
    startScrolling(scrollContainerRef1, "left", animationRef1);
    startScrolling(scrollContainerRef2, "right", animationRef2);

    return () => {
      stopScrolling(animationRef1);
      stopScrolling(animationRef2);
    };
  }, []);

  // Professional Color Theme
  const colors = {
    primary: "#1d2430",
    secondary: "#0d47a1",
    accent: "#1565c0",
    light: "#e3f2fd",
    gold: "#c9a84c",
    dark: "#0a1628",
    white: "#ffffff",
    gray: "#f8f9fa",
    text: "#1a2332",
    textLight: "#546e7a",
    gradient: "linear-gradient(135deg, #1a237e 0%, #0d47a1 50%, #1565c0 100%)",
    gradientGold: "linear-gradient(135deg, #c9a84c 0%, #f5d37c 100%)",
  };

  // Font family
  const fontFamily = "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important";

  // Responsive Styles with Font
  const styles = {
    wrapper: {
      padding: "40px 0 50px",
      background: colors.gray,
      position: "relative",
      overflow: "hidden",
      fontFamily: fontFamily,
    },
    bgDecor: {
      position: "absolute",
      top: "-50%",
      right: "-20%",
      width: "600px",
      height: "600px",
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(26,35,126,0.03) 0%, transparent 70%)",
      pointerEvents: "none",
    },
    bgDecor2: {
      position: "absolute",
      bottom: "-40%",
      left: "-10%",
      width: "500px",
      height: "500px",
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(201,168,76,0.05) 0%, transparent 70%)",
      pointerEvents: "none",
    },
    container: {
      maxWidth: "1400px",
      margin: "0 auto",
      padding: "0 20px",
      position: "relative",
      zIndex: 1,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "30px",
      paddingBottom: "15px",
      borderBottom: `2px solid ${colors.light}`,
      flexWrap: "wrap",
      gap: "15px",
    },
    titleSection: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    title: {
      fontSize: "clamp(1.8rem, 4vw, 2.8rem)",
      fontWeight: "800",
      color: colors.primary,
      margin: 0,
      letterSpacing: "-1px",
      lineHeight: 1.2,
      fontFamily: fontFamily,
    },
    titleHighlight: {
      background: colors.gradientGold,
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text",
    },
    headerStats: {
      display: "flex",
      gap: "clamp(15px, 3vw, 30px)",
      alignItems: "center",
      flexWrap: "wrap",
    },
    statItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    statNumber: {
      fontSize: "clamp(1.2rem, 2vw, 1.8rem)",
      fontWeight: "800",
      color: colors.primary,
      lineHeight: 1,
      fontFamily: fontFamily,
      minWidth: "50px",
      textAlign: "center",
    },
    statLabel: {
      fontSize: "clamp(0.6rem, 0.8vw, 0.75rem)",
      color: colors.textLight,
      fontWeight: "500",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      marginTop: "4px",
      textAlign: "center",
      fontFamily: fontFamily,
    },
    statDivider: {
      width: "1px",
      height: "clamp(30px, 4vw, 40px)",
      background: colors.light,
    },
    scrollContainer: {
      display: "flex",
      gap: "clamp(12px, 2vw, 20px)",
      whiteSpace: "nowrap",
      overflowX: "hidden",
      width: "100%",
      padding: "10px 0",
      maskImage: "linear-gradient(to right, transparent, black 5%, black 95%, transparent)",
      WebkitMaskImage: "linear-gradient(to right, transparent, black 5%, black 95%, transparent)",
    },
    logoItem: {
      flexShrink: 0,
      width: "clamp(100px, 12vw, 150px)",
      height: "clamp(70px, 8vw, 100px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: colors.white,
      borderRadius: "12px",
      boxShadow: "0 2px 12px rgba(26,35,126,0.08)",
      overflow: "hidden",
      padding: "clamp(10px, 1.5vw, 15px)",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      border: `1px solid ${colors.light}`,
      position: "relative",
    },
    logoImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      transition: "all 0.3s ease",
    },
    layerDivider: {
      height: "1px",
      margin: "5px 0 15px",
      background: `linear-gradient(90deg, transparent, ${colors.light}, transparent)`,
      width: "100%",
    },
  };

  // Hover Styles - No border change, only scale and shadow
  const logoHoverStyle = {
    ...styles.logoItem,
    transform: "translateY(-4px) scale(1.03)",
    boxShadow: "0 8px 30px rgba(26,35,126,0.12)",
    border: `1px solid ${colors.light}`,
  };

  const imageHoverStyle = {
    ...styles.logoImage,
    transform: "scale(1.05)",
  };

  const renderLogoItems = (logosArray, hoverState, setHoverState) => {
    return logosArray.concat(logosArray).map((logo, index) => (
      <div
        style={hoverState === index ? logoHoverStyle : styles.logoItem}
        key={`logo-${index}`}
        onMouseEnter={() => setHoverState(index)}
        onMouseLeave={() => setHoverState(null)}
      >
        <img
          src={logo}
          alt={`Client Logo ${index + 1}`}
          style={hoverState === index ? imageHoverStyle : styles.logoImage}
          loading="lazy"
        />
      </div>
    ));
  };

  return (
    <div style={styles.wrapper}>
      {/* Decorative Background Elements */}
      <div style={styles.bgDecor} />
      <div style={styles.bgDecor2} />

      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.titleSection}>
            <h2 style={styles.title}>
              Our Clients
            </h2>
          </div>
          
          <div style={styles.headerStats}>
            {/* Years Experience - Static */}
            <div style={styles.statItem}>
              <span style={styles.statNumber}>30+</span>
              <span style={styles.statLabel}>Years Experience</span>
            </div>
            <div style={styles.statDivider} />
            
            {/* Legal Services - From API */}
            <div style={styles.statItem}>
              <span style={styles.statNumber}>
                {loading ? "..." : serviceCounts.legal || 0}+
              </span>
              <span style={styles.statLabel}>Legal Services</span>
            </div>
            <div style={styles.statDivider} />
            
            {/* Audit Services - From API */}
            <div style={styles.statItem}>
              <span style={styles.statNumber}>
                {loading ? "..." : serviceCounts.audit || 0}+
              </span>
              <span style={styles.statLabel}>Audit Services</span>
            </div>
          </div>
        </div>

        {/* First Layer */}
        <div
          ref={scrollContainerRef1}
          style={styles.scrollContainer}
          onMouseEnter={() => {
            stopScrolling(animationRef1);
          }}
          onMouseLeave={() => {
            if (!animationRef1.current) {
              startScrolling(scrollContainerRef1, "left", animationRef1);
            }
          }}
        >
          {renderLogoItems(logos, isHovering1, setIsHovering1)}
        </div>

        <div style={styles.layerDivider} />

        {/* Second Layer */}
        <div
          ref={scrollContainerRef2}
          style={styles.scrollContainer}
          onMouseEnter={() => {
            stopScrolling(animationRef2);
          }}
          onMouseLeave={() => {
            if (!animationRef2.current) {
              startScrolling(scrollContainerRef2, "right", animationRef2);
            }
          }}
        >
          {renderLogoItems(logos_2, isHovering2, setIsHovering2)}
        </div>
      </div>

      {/* Mobile Responsive Styles with Font */}
      <style jsx>{`
        * {
          font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
        }
        
        @media (max-width: 768px) {
          .logo-item {
            width: 90px !important;
            height: 65px !important;
            padding: 8px !important;
          }
        }
        
        @media (max-width: 480px) {
          .logo-item {
            width: 75px !important;
            height: 55px !important;
            padding: 6px !important;
          }
        }
      `}</style>
    </div>
  );
}